/**
 * Evidence record schema. Plan §26.6.
 *
 * ADR-0002 red line #4: every persisted evidence record MUST carry the triplet
 * `chunkId` + `sourceUrl` + `sha256`. `r2Key` is the immutable content-addressed
 * pointer (KAIYANG-LESSONS §11 — provenance governance). Excerpt is capped at
 * 500 chars so the audit trail stays cheap to render in the review queue.
 */

import { z } from "zod";

export const EvidenceLocatorSchema = z.object({
  page: z.number().int().positive().optional(),
  xpath: z.string().optional(),
  cssSelector: z.string().optional(),
  offsetStart: z.number().int().nonnegative().optional(),
  offsetEnd: z.number().int().nonnegative().optional(),
});
export type EvidenceLocator = z.infer<typeof EvidenceLocatorSchema>;

export const EvidenceRecordSchema = z.object({
  id: z.string().uuid(),
  docId: z.string().min(1),
  chunkId: z.string().min(1),
  sourceUrl: z.string().url(),
  sha256: z.string().regex(/^[a-f0-9]{64}$/),
  locator: EvidenceLocatorSchema,
  excerpt: z.string().max(500),
  parserVersion: z.string(),
  extractedAt: z.string(),
  r2Key: z.string().min(1),
  citedByCardIds: z.array(z.string()),
  cardField: z
    .enum([
      "legalReference",
      "evidenceGuidance",
      "requirementText",
      "continuingObligation",
    ])
    .optional(),
});
export type EvidenceRecord = z.infer<typeof EvidenceRecordSchema>;
